// extracted by mini-css-extract-plugin
export default {"input":"v5-z","button":"w5-z","selected":"x5-z","unavailable":"y5-z","oos":"z5-z","image":"A5-z","paperCutDisabledOverlay":"B5-z"};